import { GET_TIPO_FICHA, ADD_TIPO_FICHA, MODIFY_TIPO_FICHA, DELETE_TIPO_FICHA, UPDATE_TIPO_FICHA } from '../constants/action_types';

const initialState = {
    tipoFichaList: [],
    isLoading: false
};

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_TIPO_FICHA:
            
            return {
                ...state,
                isLoading: true
            };

        case GET_TIPO_FICHA + "_SUCCESS":
            return {
                tipoFichaList: action.payload.data,
                isLoading: false
            };

        case ADD_TIPO_FICHA:
            
            const newArr = [...state.tipoFichaList, action.payload]
            return {
                tipoFichaList: newArr,
                isLoading: false
            };

        case MODIFY_TIPO_FICHA:
            
            return {
                tipoFichaList: state.tipoFichaList.map((p) => {
                    if (p.id !== action.payload.id) 
                        return p;
                    else
                        return action.payload
                }),
                isLoading: false
            };

        case DELETE_TIPO_FICHA:

            return {
                tipoFichaList: state.tipoFichaList.filter(p => p.id !== action.payload.id),
                isLoading: false
            };

        case UPDATE_TIPO_FICHA + "_SUCCESS":

            return state;

        default:

            return state;
    }
}